'use client'

import { HandsOnLearningFeatureProps } from '@/widgets/landing-page-widgets/HandsOnLearningSection/schema'

import { cn, Typography } from '@pw-tech/omni-ui'

const MenuCard = ({
  feature,
  isActive,
  onClick,
}: {
  feature: HandsOnLearningFeatureProps
  isActive: boolean
  onClick: () => void
}) => {
  return (
    <div
      className={cn(
        'rounded-lg p-4 transition-all duration-150 overflow-hidden',
        isActive
          ? 'border border-[#D9DCE1] bg-white'
          : ''
      )}
      style={{ boxShadow: isActive ? '0px 8px 24px 0px #0000000f' : 'none' }}
      tabIndex={0}
      role='button'
      onClick={() => (!isActive ? onClick() : null)}
    >
      <Typography
        variant='heading4'
        className={cn(isActive && '!font-bold')}
        color={isActive ? '#1b2124' : '#A1A3A4'}
      >
        {feature.title}
      </Typography>
      <Typography
        variant='regular'
        className={cn(!isActive && 'hidden')}
        color='#757575'
      >
        {feature.description}
      </Typography>
    </div>
  )
}

export default MenuCard
